import * as React from 'react';

import { useQuery } from '@apollo/client';

import { Typography2 } from '@coursera/cds-core';

import RecruitingCandidateByExternalId from 'bundles/account-profile/components/recruiting-profile-viewer/queries/RecruitingCandidateByExternalId.graphql';
import type {
  RecruitingCandidateByExternalIdQuery,
  RecruitingCandidateByExternalIdQueryVariables,
} from 'bundles/account-profile/components/recruiting-profile-viewer/queries/__generated__/RecruitingCandidateByExternalId';

type PropsFromCaller = {
  externalId: string;
};

const EmailSection = ({ externalId }: PropsFromCaller) => {
  // This query will only return email if:
  //     - the viewing user has UA Reskill organization recruiter view permissions
  //     - the candidate is in the UA Reskill organization
  // Otherwise, it will return permission denied.
  const { data } = useQuery<RecruitingCandidateByExternalIdQuery, RecruitingCandidateByExternalIdQueryVariables>(
    RecruitingCandidateByExternalId,
    {
      variables: {
        externalId,
      },
      context: { clientName: 'gatewayGql' },
    }
  );

  const email = data?.RecruitingCandidate?.queryByExternalId?.email;

  return (
    <React.Fragment>
      {email && (
        <Typography2 className="pii-hide fs-exclude" variant="bodyPrimary" component="p">
          {email}
        </Typography2>
      )}
    </React.Fragment>
  );
};

export default EmailSection;
